module.exports = __webpack_public_path__ + "img/image56.d59f14da.png";